module.exports = __webpack_public_path__ + "static/img/7.3045cb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/7.jpg
// module id = YYeH
// module chunks = 1